import { useMutation } from "urql";

import { InactivateLimitDocument } from "../../../graphql/generated.ts";

export const useInactivateLimit = () => useMutation(InactivateLimitDocument);
